import "./styles.css";
import "modern-normalize/modern-normalize.css";
import Game from "./game.js";

new Game();
